import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { FOOTER_LINKS } from "../../content/site";
import { Wave } from "../ui/decor";

export function Footer() {
  return (
    <footer className="relative bg-navy-950">
      {/* Chunky wavy top edge so the dark block melts into the cream page. */}
      <Wave fill="#FFF6EC" flip />

      <div className="container-x pt-10 sm:pt-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo className="[&>span:last-child]:text-white" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
              The scale that pays you. Lose weight, bank calories, and eat like
              you've earned it — because you have.
            </p>
          </div>

          {Object.entries(FOOTER_LINKS).map(([group, links]) => (
            <div key={group}>
              <h3 className="font-display text-sm font-extrabold uppercase tracking-wide text-sun">
                {group}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {links.map((l) => (
                  <li key={l.href}>
                    {l.href.startsWith("/") ? (
                      <Link
                        to={l.href}
                        className="text-sm text-white/70 transition-colors hover:text-white"
                      >
                        {l.label}
                      </Link>
                    ) : (
                      <a
                        href={l.href}
                        className="text-sm text-white/70 transition-colors hover:text-white"
                      >
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t-2 border-white/10 pt-6 text-xs text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} FitBuddy · usefitbuddy.com</p>
          <p className="text-center sm:text-right">
            FitBuddy is a weight-loss companion, not a medical device or medical
            advice. Always follow your clinician's guidance.
          </p>
        </div>
      </div>

      {/* Oversized wordmark cropped by the bottom edge — the playful sign-off. */}
      <div aria-hidden className="overflow-hidden">
        <p className="display container-x select-none whitespace-nowrap text-center text-[19vw] leading-[0.78] text-white/10 sm:text-[13rem]">
          Fit<span className="text-teal-light/20">Buddy</span>
        </p>
      </div>
    </footer>
  );
}
